export const CREATE_NEW_LIST = 'Create New List';

export default CREATE_NEW_LIST;
export const TITLE_POPUP_CREATE_LIST = CREATE_NEW_LIST;
export const LABEL_BUTTON_ADD_NEW_LIST = CREATE_NEW_LIST;
